"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _construct2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/construct"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/toConsumableArray"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));
var _react = _interopRequireDefault(require("react"));
var _Hooks = require("../Hooks");
var _TaskGraphSlider = _interopRequireWildcard(require("./TaskGraphSlider"));
/*
GraphSlider has:
A variable number of sliders
Configurable, multi-segmented mapping between slider position and variable value
Alt text and body text for combinations of different ranges between sliders
A graph equation that changes with the sliders
multiple ChartJS graph configuration

it is a controlled component


TaskGraphSliderConfigurable props:
number of points for the graph
Configurable, multi-segmented mapping between slider position and variable value
List of graphs, and for each a list of equations and/or points to graph based on slider variables
ChartJS configuration for the equations/points
List of regions and body/alt text for each

it is an uncontrolled component
*/

function TaskGraphSliderConfigurable(_ref) {
  var state = _ref.state,
    spaceBetweenPoints = _ref.spaceBetweenPoints,
    trackRanges = _ref.trackRanges,
    sliders = _ref.sliders,
    texts = _ref.texts,
    graphs = _ref.graphs,
    equations = _ref.equations,
    pointSets = _ref.pointSets;
  // Slider state management
  var _useStorageState = (0, _Hooks.useStorageState)(state, "sliderValues", sliders.map(function (slider) {
      return 0;
    })),
    _useStorageState2 = (0, _slicedToArray2.default)(_useStorageState, 2),
    sliderValues = _useStorageState2[0],
    setSliderValues = _useStorageState2[1]; // todo: calculate value
  var _useStorageState3 = (0, _Hooks.useStorageState)(state, "sliderPositions", sliders.map(function (slider) {
      return slider.initialPosition;
    })),
    _useStorageState4 = (0, _slicedToArray2.default)(_useStorageState3, 2),
    sliderPositions = _useStorageState4[0],
    setSliderPositions = _useStorageState4[1];
  return /*#__PURE__*/_react.default.createElement(_TaskGraphSlider.default, {
    state: state,
    sliders: sliders.map(function (slider, i) {
      return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, slider), {}, {
        value: sliderValues[i],
        setValue: function setValue(v) {
          sliderValues[i] = v;
          setSliderValues(sliderValues.slice());
        },
        position: sliderPositions[i],
        setPosition: function setPosition(v) {
          sliderPositions[i] = v;
          setSliderPositions(sliderPositions.slice());
        },
        initialPosition: slider.initialPosition,
        label: slider.label,
        ariaLabelForHandle: slider.ariaLabelForHandle
      });
    }),
    trackRanges: trackRanges,
    displayText: texts,
    graphs: graphs.map(function (graph, i) {
      var _graph$options, _graph$options$scales, _graph$options2, _graph$options2$scale, _graph$options2$scale2, _graph$options2$scale3, _graph$options3, _graph$options3$scale, _graph$options3$scale2, _graph$options4, _graph$options4$scale, _graph$options4$scale2, _graph$options6, _graph$options6$scale, _graph$options6$scale2, _graph$options7, _graph$options7$scale, _graph$options8, _graph$options8$scale, _graph$options8$scale2, _graph$options8$scale3, _graph$options9, _graph$options9$scale, _graph$options9$scale2, _graph$options10, _graph$options10$scal, _graph$options10$scal2, _graph$options12, _graph$options12$scal, _graph$options12$scal2, _graph$plugins;
      var variables = sliders.map(function (v, k) {
        return String.fromCharCode(97 + k);
      });
      // Set up default values and merge in configuration
      var config = {
        data: {
          datasets: {}
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          animation: false,
          scales: {
            x: (0, _objectSpread2.default)((0, _objectSpread2.default)({
              min: 0,
              max: 30
            }, graph === null || graph === void 0 ? void 0 : (_graph$options = graph.options) === null || _graph$options === void 0 ? void 0 : (_graph$options$scales = _graph$options.scales) === null || _graph$options$scales === void 0 ? void 0 : _graph$options$scales.x), {}, {
              title: (0, _objectSpread2.default)({
                display: graph !== null && graph !== void 0 && (_graph$options2 = graph.options) !== null && _graph$options2 !== void 0 && (_graph$options2$scale = _graph$options2.scales) !== null && _graph$options2$scale !== void 0 && (_graph$options2$scale2 = _graph$options2$scale.x) !== null && _graph$options2$scale2 !== void 0 && (_graph$options2$scale3 = _graph$options2$scale2.title) !== null && _graph$options2$scale3 !== void 0 && _graph$options2$scale3.text ? true : false,
                color: "#6e6e6e",
                align: "end",
                font: {
                  size: 18
                }
              }, graph === null || graph === void 0 ? void 0 : (_graph$options3 = graph.options) === null || _graph$options3 === void 0 ? void 0 : (_graph$options3$scale = _graph$options3.scales) === null || _graph$options3$scale === void 0 ? void 0 : (_graph$options3$scale2 = _graph$options3$scale.x) === null || _graph$options3$scale2 === void 0 ? void 0 : _graph$options3$scale2.title),
              grid: (0, _objectSpread2.default)({
                display: true,
                drawOnChartArea: false,
                drawTicks: true
              }, graph === null || graph === void 0 ? void 0 : (_graph$options4 = graph.options) === null || _graph$options4 === void 0 ? void 0 : (_graph$options4$scale = _graph$options4.scales) === null || _graph$options4$scale === void 0 ? void 0 : (_graph$options4$scale2 = _graph$options4$scale.x) === null || _graph$options4$scale2 === void 0 ? void 0 : _graph$options4$scale2.grid),
              ticks: (0, _objectSpread2.default)({
                callback: function callback(val, index) {
                  var _graph$options$scales2, _graph$options5, _graph$options5$scale, _graph$options5$scale2;
                  return val % ((_graph$options$scales2 = graph === null || graph === void 0 ? void 0 : (_graph$options5 = graph.options) === null || _graph$options5 === void 0 ? void 0 : (_graph$options5$scale = _graph$options5.scales) === null || _graph$options5$scale === void 0 ? void 0 : (_graph$options5$scale2 = _graph$options5$scale.x) === null || _graph$options5$scale2 === void 0 ? void 0 : _graph$options5$scale2.tickInterval) !== null && _graph$options$scales2 !== void 0 ? _graph$options$scales2 : 5) === 0 ? val : '';
                }
              }, graph === null || graph === void 0 ? void 0 : (_graph$options6 = graph.options) === null || _graph$options6 === void 0 ? void 0 : (_graph$options6$scale = _graph$options6.scales) === null || _graph$options6$scale === void 0 ? void 0 : (_graph$options6$scale2 = _graph$options6$scale.y) === null || _graph$options6$scale2 === void 0 ? void 0 : _graph$options6$scale2.ticks)
            }),
            y: (0, _objectSpread2.default)((0, _objectSpread2.default)({
              min: 0,
              max: 30
            }, graph === null || graph === void 0 ? void 0 : (_graph$options7 = graph.options) === null || _graph$options7 === void 0 ? void 0 : (_graph$options7$scale = _graph$options7.scales) === null || _graph$options7$scale === void 0 ? void 0 : _graph$options7$scale.y), {}, {
              title: (0, _objectSpread2.default)({
                display: graph !== null && graph !== void 0 && (_graph$options8 = graph.options) !== null && _graph$options8 !== void 0 && (_graph$options8$scale = _graph$options8.scales) !== null && _graph$options8$scale !== void 0 && (_graph$options8$scale2 = _graph$options8$scale.y) !== null && _graph$options8$scale2 !== void 0 && (_graph$options8$scale3 = _graph$options8$scale2.title) !== null && _graph$options8$scale3 !== void 0 && _graph$options8$scale3.text ? true : false,
                color: "#6e6e6e",
                align: "end",
                font: {
                  size: 18
                }
              }, graph === null || graph === void 0 ? void 0 : (_graph$options9 = graph.options) === null || _graph$options9 === void 0 ? void 0 : (_graph$options9$scale = _graph$options9.scales) === null || _graph$options9$scale === void 0 ? void 0 : (_graph$options9$scale2 = _graph$options9$scale.y) === null || _graph$options9$scale2 === void 0 ? void 0 : _graph$options9$scale2.title),
              grid: (0, _objectSpread2.default)({
                display: true,
                drawOnChartArea: false,
                drawTicks: true
              }, graph === null || graph === void 0 ? void 0 : (_graph$options10 = graph.options) === null || _graph$options10 === void 0 ? void 0 : (_graph$options10$scal = _graph$options10.scales) === null || _graph$options10$scal === void 0 ? void 0 : (_graph$options10$scal2 = _graph$options10$scal.y) === null || _graph$options10$scal2 === void 0 ? void 0 : _graph$options10$scal2.grid),
              ticks: (0, _objectSpread2.default)({
                callback: function callback(val, index) {
                  var _graph$options$scales3, _graph$options11, _graph$options11$scal, _graph$options11$scal2;
                  return val % ((_graph$options$scales3 = graph === null || graph === void 0 ? void 0 : (_graph$options11 = graph.options) === null || _graph$options11 === void 0 ? void 0 : (_graph$options11$scal = _graph$options11.scales) === null || _graph$options11$scal === void 0 ? void 0 : (_graph$options11$scal2 = _graph$options11$scal.y) === null || _graph$options11$scal2 === void 0 ? void 0 : _graph$options11$scal2.tickInterval) !== null && _graph$options$scales3 !== void 0 ? _graph$options$scales3 : 5) === 0 ? val : '';
                }
              }, graph === null || graph === void 0 ? void 0 : (_graph$options12 = graph.options) === null || _graph$options12 === void 0 ? void 0 : (_graph$options12$scal = _graph$options12.scales) === null || _graph$options12$scal === void 0 ? void 0 : (_graph$options12$scal2 = _graph$options12$scal.y) === null || _graph$options12$scal2 === void 0 ? void 0 : _graph$options12$scal2.ticks)
            })
          },
          plugins: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, graph === null || graph === void 0 ? void 0 : graph.plugins), {}, {
            legend: (0, _objectSpread2.default)({
              display: false
            }, graph === null || graph === void 0 ? void 0 : (_graph$plugins = graph.plugins) === null || _graph$plugins === void 0 ? void 0 : _graph$plugins.legend)
          })
        }
      };
      config.data.datasets = equations[i].map(function (equation) {
        var data = [];
        var f = (0, _construct2.default)(Function, (0, _toConsumableArray2.default)(variables).concat(["x", "return " + equation.yEquals]));
        for (var x = config === null || config === void 0 ? void 0 : (_config$options = config.options) === null || _config$options === void 0 ? void 0 : (_config$options$scale = _config$options.scales) === null || _config$options$scale === void 0 ? void 0 : (_config$options$scale2 = _config$options$scale.x) === null || _config$options$scale2 === void 0 ? void 0 : _config$options$scale2.min; x <= (config === null || config === void 0 ? void 0 : (_config$options2 = config.options) === null || _config$options2 === void 0 ? void 0 : (_config$options2$scal = _config$options2.scales) === null || _config$options2$scal === void 0 ? void 0 : (_config$options2$scal2 = _config$options2$scal.x) === null || _config$options2$scal2 === void 0 ? void 0 : _config$options2$scal2.max); x += (_graph$spaceBetweenPo = graph === null || graph === void 0 ? void 0 : graph.spaceBetweenPoints) !== null && _graph$spaceBetweenPo !== void 0 ? _graph$spaceBetweenPo : spaceBetweenPoints) {
          var _config$options, _config$options$scale, _config$options$scale2, _config$options2, _config$options2$scal, _config$options2$scal2, _graph$spaceBetweenPo;
          data.push({
            x: x,
            y: f.apply(void 0, (0, _toConsumableArray2.default)(sliders.map(function (v, k) {
              return sliderValues[k];
            })).concat([x]))
          });
        }
        return (0, _objectSpread2.default)((0, _objectSpread2.default)({
          pointRadius: 0,
          borderColor: 'rgba(255, 165, 0, 0.5)',
          fill: false,
          showLine: true
        }, equation), {}, {
          data: data
        });
      }).concat(pointSets[i].map(function (points) {
        return (0, _objectSpread2.default)((0, _objectSpread2.default)({
          label: 'Fixed points',
          fill: true,
          borderColor: 'rgb(0, 0, 0)',
          backgroundColor: 'rgb(0, 0, 0)',
          borderDash: [0, 10]
        }, points), {}, {
          data: points.map(function (point) {
            var fx = (0, _construct2.default)(Function, (0, _toConsumableArray2.default)(variables).concat(["return " + point.xEquals]));
            var fy = (0, _construct2.default)(Function, (0, _toConsumableArray2.default)(variables).concat(["return " + point.yEquals]));
            return {
              x: fx.apply(void 0, (0, _toConsumableArray2.default)(sliders.map(function (v, k) {
                return sliderValues[k];
              }))),
              y: fy.apply(void 0, (0, _toConsumableArray2.default)(sliders.map(function (v, k) {
                return sliderValues[k];
              })))
            };
          })
        });
      }));
      return config;
    })
  });
}
TaskGraphSliderConfigurable.sliderValueToGraphValue = _TaskGraphSlider.sliderValueToGraphValue;
var _default = TaskGraphSliderConfigurable;
exports.default = _default;